import type { RoutingWorkerPort } from "./venueMapRoutingClient";

/** Own the URL in the page realm so cancellation before startup cannot leak it. */
export function createInlineRoutingWorker(source: string): RoutingWorkerPort {
  const url = URL.createObjectURL(
    new Blob([source], { type: "text/javascript" }),
  );
  let worker: Worker | undefined;
  let released = false;
  const release = () => {
    if (released) return;
    released = true;
    URL.revokeObjectURL(url);
    worker?.removeEventListener("message", release);
    worker?.removeEventListener("error", release);
  };
  try {
    worker = new Worker(url, { name: "event-map-routing" });
    // Once any reply arrives, the script has loaded. Termination and failure
    // release the URL even when startup never reached the first message.
    worker.addEventListener("message", release, { once: true });
    worker.addEventListener("error", release, { once: true });
  } catch (error) {
    release();
    throw error;
  }
  const instance = worker;
  return {
    get onmessage() {
      return instance.onmessage;
    },
    set onmessage(handler) {
      instance.onmessage = handler;
    },
    get onerror() {
      return instance.onerror;
    },
    set onerror(handler) {
      instance.onerror = handler;
    },
    get onmessageerror() {
      return instance.onmessageerror;
    },
    set onmessageerror(handler) {
      instance.onmessageerror = handler;
    },
    postMessage(message) {
      instance.postMessage(message);
    },
    terminate() {
      release();
      instance.terminate();
    },
  };
}
